import { render, staticRenderFns } from "./BrandCreateScreen.vue?vue&type=template&id=ea94d0e6&"
import script from "./BrandCreateScreen.vue?vue&type=script&lang=js&"
export * from "./BrandCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports